import { FC } from 'react';

import { getErrorMessage } from '../../constants/errors';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './styles.errorModal';

export type ErrorObject = {
    code: string;
    message?: string;
}
const ErrorMessage: FC<{error: ErrorObject}> = ({ error }) => {
  const { toggleModal } = useModalContext();
  const { translate, currentLocale : { locale } } = useI18nContext();

  return (
    <Styles.Wrapper>
      <Styles.ErrorMessage
        id ="error-message-text"
        dangerouslySetInnerHTML={{ __html : getErrorMessage(error.code, locale, error.message || '') }} />
      {error?.code && (
        <Styles.ErrorCode id="error-message-code">
          {translate(['INFORMATION', 'ERROR_CODE'])}: {error.code}
        </Styles.ErrorCode>
      )}
      <Styles.Footer>
        <Styles.ActionButton onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.ActionButton>
        {error?.code !== 'LG6013' && (<Styles.ActionButton $strong onClick={() => window.open('https://ingresse.freshdesk.com/support/home','_blank')}>
          {translate(['INFORMATION', 'SUPPORT'])}
        </Styles.ActionButton>)}
      </Styles.Footer>
    </Styles.Wrapper>
  );
};

export default ErrorMessage;
